import { Color, Style } from "./alert-variants.ts";
import { FontStyles } from "../../utils/font-styles.ts";
import { CalloutBox } from "../base/callout-box";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";
import { ReactElement, ReactNode } from "react";

interface AlertProps {
  title?: string;
  message: ReactNode;
  color: Color;
  style: Style;
  dismissible?: boolean;
  onDismiss?: () => void;
  renderLeadingIcon?: () => ReactElement;
}

const textContainer = "flex flex-col mr-4 min-w-40";
const iconContainer = "flex justify-center items-center self-stretch";
const titleStyle = "font-semibold " + FontStyles["body-l"];
const messageStyle = "font-normal " + FontStyles["body-md"];

export const Alert = ({
  title,
  message,
  color,
  style,
  dismissible = false,
  onDismiss,
  renderLeadingIcon,
}: AlertProps) => {
  const title_style: string[] = [titleStyle];
  const message_style: string[] = [messageStyle];

  const icon = renderLeadingIcon?.() ?? null;

  return (
    <CalloutBox color={color} style={style}>
      {icon && <div className={iconContainer}>{icon}</div>}
      <div className={textContainer}>
        <span className={title_style.join(" ")}>{title}</span>
        <span className={message_style.join(" ")}>{message}</span>
      </div>
      {dismissible && (
        <button
          type="button"
          aria-label="Dismiss alert"
          className={`${iconContainer} cursor-pointer ml-auto`}
          onClick={() => onDismiss?.()}
        >
          <i className="fa-sharp fa-regular fa-xmark text-2xl" />
        </button>
      )}
    </CalloutBox>
  );
};
